export const environment = {
  name: 'staging',
  production: true,
  realm: 'eoda-staging'
};
